/**
 * Formats a number as a currency string.
 * Usage: formatPrice(19999) -> "GHS 19,999.00"
 * @param {number|string} amount 
 * @returns {string}
 */
export const formatPrice = (amount) => {
    const num = parseFloat(amount);
    if (isNaN(num)) return 'GHS 0.00';

    return new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num).replace('GHS', 'GHS ').trim(); // Ensure space if Intl doesn't add it consistently or if we want specific spacing
};
